<div class="auth-wrapper">
    <div class="container pt-3 fade-in-left">
            <div class="d-flex align-items-center justify-content-center mb-4">
                <a [routerLink]="['/sign-in']" class="p-2"><div><i class="bi bi-chevron-left align-middle"></i></div></a>
                <div class="p-2 flex-grow-1 pl-2"><h1 class="text-dark text-center ">Registro de {{perfil()}}</h1></div>
            </div>
        
            <div class="row-cols-12 m-4 mt-4">
                <div class="p-3">  
                    <div class="row description mb-2">
                    <form (ngSubmit)="registrar()" [formGroup]="registrarUsuario">
                        @if(idPerfil() == 3){
                            <div class="mb-3 text-center form-floating">
                                <img src="./assets/img/prestador.png" class="img-fluid rounded-4 w-100 mb-2" alt="Prestador">
                                <p>Estás a un paso de registrarte como nuevo <strong>PRESTADOR</strong>, completá los siguientes datos por favor</p>
                            </div>
                        }
                        @if(idPerfil() == 4){
                            <div class="mb-3 text-center form-floating">
                                <img src="./assets/img/comercio.png" class="img-fluid rounded-4 w-100 mb-2" alt="Prestador">
                                <p>Estás a un paso de registrarte como nuevo <strong>COMERCIO</strong>, completá los siguientes datos por favor</p>
                            </div>
                        }
                        <div class="mb-3 text-start form-floating">
                            <input type="email" autocomplete="email" class="form-control" id="email" aria-describedby="emailHelp" formControlName="email" placeholder="ejemplo@email.com">
                            <label for="email" class="form-label">Email</label>
                            @if (registrarUsuario.controls.email.touched && registrarUsuario.controls.email.invalid) {
                                @if (registrarUsuario.controls.email.errors?.['required']) {
                                    <div class="alert-danger"><small class="alert">Email es requerido</small></div>
                                }
                                @if (registrarUsuario.controls.email.errors?.['email']) {
                                    <div class="alert-danger"><small class="alert">Email inválido</small></div>
                                }
                            }
                        </div>
                        @if(idPerfil() == 2){
                            <div class="mb-3 text-start form-floating">
                                <input type="text" class="form-control" id="nro_socio" formControlName="nro_socio" placeholder="Nro. Socio"/>
                                <label for="nro_socio" class="form-label">Nro. Socio</label>
                                @if (registrarUsuario.controls.nro_socio.touched && registrarUsuario.controls.nro_socio.invalid) {
                                    @if (registrarUsuario.controls.nro_socio.errors?.['required']) {
                                        <div class="alert-danger"><small class="alert">Nro. Socio es requerido</small></div>
                                    }
                                    @if (registrarUsuario.controls.nro_socio.errors?.['nro_socio']) {
                                        <div class="alert-danger"><small class="alert">Nro. Socio inválido</small></div>
                                    }
                                }
                            </div>
                        }
                        <div class="mb-3 text-start form-floating">
                            <input [type]="fieldTextType() ? 'text' : 'password'" autocomplete="new-password" class="form-control" id="clave" formControlName="clave" placeholder="Ingrese su clave" (focus)="mostrarRequisitos()">
                            <label for="clave" class="form-label">Clave</label>
                            <i class="bi seePassword"
                                [class.bi-eye-slash]="!fieldTextType()"
                                [class.bi-eye]="fieldTextType()"
                                (click)="toggleFieldTextType()">
                            </i>
                            @if (registrarUsuario.controls.clave.touched && registrarUsuario.controls.clave.invalid) {
                                @if (registrarUsuario.controls.clave.errors?.['required']) {
                                    <div class="alert-danger"><small class="alert">La clave es requerida</small></div>
                                }
                                @if (registrarUsuario.controls.clave.errors?.['minLength']) {
                                    <div class="alert-danger"><small class="alert">Mínimo 6 caracteres</small></div>
                                }
                                @if (registrarUsuario.controls.clave.errors?.['pattern']) {
                                    <div class="alert-danger">
                                        <small class="alert">
                                            Debe tener al menos una minúscula, una mayúscula y un número
                                        </small>
                                    </div>
                                }
                            }
                        </div>
                        <!-- REPETIR CLAVE -->
                        <div class="mb-5 text-start form-floating">
                            <input  [type]="fieldTextType() ? 'text' : 'password'" class="form-control" id="repetirClave" formControlName="repetirClave" placeholder="Repetir su clave" (focus)="mostrarRequisitos()">
                            <label for="repetirClave" class="form-label">Repetir Clave</label>
                            <i class="bi seePassword"
                                [class.bi-eye-slash]="!fieldTextType()"
                                [class.bi-eye]="fieldTextType()"
                                (click)="toggleFieldTextType()">
                            </i>
                            @if (registrarUsuario.touched && registrarUsuario.errors?.['passwordsMismatch']) {
                                <div class="alert-danger"><small class="alert">Las claves deben coincidir</small></div>
                            }
                        </div>
                        <!-- Acepto T&C -->
                        <div class="mb-3 form-check text-start">
                            <input type="checkbox" class="form-check-input" id="acepta" formControlName="aceptaTyC">
                            <label for="acepta" class="form-check-label text-dark">
                                Acepto los
                                <a [routerLink]="['/terminos-condiciones', idPerfil()]">Términos y Condiciones</a>
                                y la
                                <a routerLink="/politica-privacidad">Política de Privacidad</a>.
                            </label>
                            @if (registrarUsuario.controls.aceptaTyC.touched && registrarUsuario.controls.aceptaTyC.invalid) {
                                <div class="alert-danger"><small class="alert">Debes aceptar los Términos</small></div>
                            }
                        </div>
                        <!-- Mensajes -->
                        @if (error()) {
                            <div class="alert alert-danger" role="alert"><small>{{ error() }}</small></div>
                        }
                        <!-- Botón -->
                        <div class="d-grid mt-0 mb-2">
                            <button type="submit" class="btn btn-primary btn-lg mt-0" [disabled]="loading() || registrarUsuario.disabled">
                                {{(loading()) ? 'Cargando...' : 'Crear cuenta'}}
                            </button>
                        </div>
                        <!-- Link a login -->
                        <hr class="hr border-white opacity-30 mt-5">

                        <p class="mt-3 text-link-small text-center"><a [routerLink]="['/sign-in']">¿Ya tenés cuenta? Ingresá</a></p>
                    </form>
                    <div class="btn-back text-center">
                        ¿Sos un prestador?<a (click)="signUpXPerfil(3)"> Clic acá</a>
                    </div>
                    <div class="btn-back text-center">
                        ¿Sos un comercio?<a (click)="signUpXPerfil(4)"> Clic acá</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>